module.exports = __webpack_public_path__ + "img/zhanwei2.bb5ad3a.png";